import { SynchronimeterSideBySide } from "../../phases/prePhase/synchro/SynchronimeterSideBySide";

export const ProjectFamily = () => {
    return <div>
        <SynchronimeterSideBySide />
    </div>;
}